import React from 'react';
import { UitkLayoutGrid, UitkLayoutGridItem } from 'uitk-react-layout-grid';
import { UitkFigure, UitkFigureAspectRatioType } from 'uitk-react-images';
import { UitkBlockSkeleton } from 'uitk-react-skeleton';
import { Viewport, ViewSmall, ViewMedium } from '@shared-ui/viewport-context';
import { UitkCard } from 'uitk-react-cards';

export const skeleton = () => (
    <>
      <UitkLayoutGrid className="activity-view-skeleton-title" rows={1}>
        <UitkLayoutGridItem rowSpan={1}>
          <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
            <UitkBlockSkeleton />
          </UitkFigure>
        </UitkLayoutGridItem>
      </UitkLayoutGrid>
      <UitkCard padded>
        <Viewport>
          <ViewSmall>
            <UitkLayoutGrid className="activity-view-skeleton-mobile-card" columns={1} space="three">
              <UitkLayoutGridItem colSpan={1}>
                <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                  <UitkBlockSkeleton />
                </UitkFigure>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </ViewSmall>
          <ViewMedium>
            <UitkLayoutGrid columns={3} space="three">
              <UitkLayoutGridItem colSpan={1}>
                <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                  <UitkBlockSkeleton />
                </UitkFigure>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={1}>
                <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                  <UitkBlockSkeleton />
                </UitkFigure>
              </UitkLayoutGridItem>
              <UitkLayoutGridItem colSpan={1}>
                <UitkFigure ratio={UitkFigureAspectRatioType.R1_1}>
                  <UitkBlockSkeleton />
                </UitkFigure>
              </UitkLayoutGridItem>
            </UitkLayoutGrid>
          </ViewMedium>
        </Viewport>
      </UitkCard>
    </>
  );